import Mosaic from './mosaic';
import ScrollMagic from "scrollmagic";
import { PageEvent } from '~/pages/page.js';

export default class MosaicDesktop extends Mosaic {
    constructor(...args) {
        super(...args);

        this._isDesktop = (ENV.device == 'desktop');

        this._retrieveDOM();
    }

    _retrieveDOM() {
        this.dom.mosaic = this.dom.component;;
        if (this.dom.mosaic) {
            this.dom.animate = {
                background: this.dom.mosaic.querySelectorAll('.js-anim-background'),
                mask: this.dom.mosaic.querySelector('.js-anim-mask')
            };
        }
    }

    init() {
        super.init();

        this._initScrollAnim();
    }

    _initScrollAnim() {
        if (this.dom.mosaic) {
            this._animMosaic();
        }
    }

    _animMosaic() {
        /** MOSAIC BACKGROUND **/
        // Create Tweenmax Animation
        let tweenBackground = new TimelineMax();
        if (this._isDesktop && this.dom.animate.background)
            tweenBackground
                .fromTo(this.dom.animate.background, 5, { scale: 1.15 }, { scale: 1, ease: Power1.easeOut })

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.mosaic,
            offset: -window.innerHeight / 2,
            duration: this.dom.mosaic.offsetHeight * 1.5
        });
        scene.setTween(tweenBackground);
        this.emit(PageEvent.ADD_SCENE, scene);


        /** MOSAIC MASK TEXT **/
        let tweenContent = new TimelineMax();
        if (this.dom.animate.mask)
            tweenContent
                .fromTo(this.dom.animate.mask, 5, { x: 0 }, { x: '100%', ease: Power1.easeOut })

        // Plug the tween to ScrollMagic Scene
        scene = new ScrollMagic.Scene({
            triggerElement: this.dom.mosaic,
            // offset: -window.innerHeight / 4,
            // duration: this.dom.mosaic.offsetHeight,
            triggerHook: 0.75,
            duration: 150
        });
        scene.setTween(tweenContent);
        this.emit(PageEvent.ADD_SCENE, scene);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}




// WEBPACK FOOTER //
// src/js/components/mosaic/mosaic.desktop.js